export default __webpack_public_path__ + "static/media/servicio-hospedaje-compartido.c14f0246.jpg";